/** Only http(s) links may be stored or rendered as href. */
export function isSafeUrl(value: string): boolean {
  try {
    const u = new URL(value.trim());
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

export function safeHref(value: string | null | undefined): string | undefined {
  return value && isSafeUrl(value) ? value.trim() : undefined;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(normalizeEmail(value));
}

export function normalizeEmployeeCode(value: string): string {
  return value.trim().toUpperCase();
}

export function isValidEmployeeCode(value: string): boolean {
  return /^[A-Z0-9._-]{2,20}$/.test(normalizeEmployeeCode(value));
}

/** CSV cell with quote escaping and spreadsheet formula neutralisation. */
export function csvCell(value: unknown): string {
  let s = value === null || value === undefined ? "" : String(value);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
}

export function toCsv(rows: unknown[][]): string {
  return "﻿" + rows.map((r) => r.map(csvCell).join(",")).join("\r\n");
}
